<template>
  <div class="form-group centix-vue-listinput row" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
      <label v-if="!info" :class="labelCssClass" class="col-form-label">{{ label }}</label>
      <div v-else :class="labelCssClass">
        <label class="col-form-label">{{ label }}</label>
        <span><img src="@/assets/info.svg" class="info align-middle ml-3" data-toggle="tooltip" data-placement="top" v-bind:title="info"/></span>
      </div>
      <span class="holder-span" :class="inputCssClass">
        <date-input v-model="localvalue" @value-changed="valueChanged" :is-enabled="isEnabled" :required="required" class="input-item" :show-hours="false" :show-minutes="false"/>
        <a v-show="validDate && isEnabled" href="javascript:void(0);" @click.stop="clearForm" class="clear-button"></a>
      </span>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>
<script>
import dateinput from 'components/Input/DateTimeInput.vue';
import FormMixin from './formitem.js';

export default {
  mixins: [FormMixin],
  components: {
    'date-input': dateinput
  },
  props: {
    value: {
      // type: [Number, String, undefined],
      required: true
    }
  },
  data () {
    return {
      formType: 'date',
      localvalue: null,
      selectedItem: null
    };
  },
  mounted () {
    this.localvalue = this.value;
  },
  methods: {
    raiseValueChanged (val) {
      this.$emit('change', val);
      this.emitFormChange();
    },
    valueChanged (val) {
      this.$log('value changed from inner component', val);
      if (val !== this.value) {
        this.raiseValueChanged(val);
      }
    },
    clearForm() {
      this.raiseValueChanged('');
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    validDate () {
      return true;
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.localvalue = newvalue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-listinput {
  span.holder-span {
    position: relative;
    display: block;
    max-width: 186px;
    padding-right: 36px;
    &:hover {
      .clear-button {
        display: block;
      }
    }
  }
  .clear-button {
    display: none;
    position: absolute;
    right: 0;
    top: 0;
    background: url('../../assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 50px;
    height: 100%;
    cursor: pointer;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }
      &.filled {
        padding-right: 25px;
        border: 2px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
</style>
